
// Vanilla JS version of navigation-search-enabler
// Looks for [data-controller="navigation-search-enabler"] and sets up logic for text field and button
export default () => {
	document.addEventListener('DOMContentLoaded', function () {
		const roots = document.querySelectorAll('[data-controller="navigation-search-enabler"]');
		if (!roots.length) return;

		roots.forEach(function(root) {
			const textField = root.querySelector('[data-navigation-search-enabler-target="textField"]');
			const button = root.querySelector('[data-navigation-search-enabler-target="button"]');
			if (!textField || !button) return;

			function handleInput() {
				const value = textField.value;
				if (value.length >= 3) {
					button.classList.remove('disabled');
					button.classList.add('primary');
				} else {
					button.classList.remove('primary');
					button.classList.add('disabled');
				}
			}

			textField.addEventListener('input', handleInput);
		});
	});
};
